import { SearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'access' },
  { name: 'aut' },
  { name: 'contintent' },
  { name: 'country' },
  { name: 'coll' },
  { name: 'ddc' },
  { name: 'doctype' },
  { name: 'doi' },
  { name: 'lang' },
  { name: 'year' },
  { name: 'publ' },
  { name: 'rights' },
  { name: 'subj' },
  { name: 'tit' },
  { name: 'url' }
]

class BaseEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('BASE')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
  }
  mapOperator (operator) {
    switch (operator) {
      case 'AND': return { op: 'AND', spaces: true }
      case 'OR': return { op: '', spaces: true }
      case 'NOT': return { op: '', spaces: true }
    }
    return { op: operator, spaces: true }
  }
  formulateQueryFromTreeDataInternal (treeData, parentFieldSpecifier) {
    if (typeof treeData.children === 'undefined') {
      return this.formTerm(treeData.text)
    }
    let r = ''
    let isFirst = true
    const thisOperator = treeData.operator || 'AND'
    const mappedThisOperator = this.mapOperator(thisOperator)
    const thisChildrenCount = treeData.children.length
    let wasPreviousGroup = false
    for (const i of treeData.children) {
      if (i.isOperator) {
        continue
      }
      if (!isFirst) {
        if (mappedThisOperator.spaces) {
          r += ' '
        }
        if (thisOperator === 'AND' && wasPreviousGroup && i.children && i.children.length > 0) {
          r += mappedThisOperator.op
        }
        if (mappedThisOperator.spaces && mappedThisOperator.op !== '') {
          r += ' '
        }
      }
      if (isFirst) {
        isFirst = false
      }
      let fieldSpecifier = null
      if (i.fieldSpecifier) {
        fieldSpecifier = i.fieldSpecifier
      } else if (parentFieldSpecifier) {
        fieldSpecifier = parentFieldSpecifier
      }
      if (i.children && i.children.length > 0) {
        if (i.isNegative) {
          r += 'NOT '
        }
        const addBrackets = i.isNegative || thisChildrenCount > 1
        if (addBrackets) {
          r += '('
        }
        r += this.formulateQueryFromTreeDataInternal(i, fieldSpecifier)
        if (addBrackets) {
          r += ')'
        }
        wasPreviousGroup = true
      } else {
        r += this.formTerm(i.text, i.isNegative, this.addQuotes(i), fieldSpecifier)
        wasPreviousGroup = false
      }
    }
    return r
  }
  formulateQuery (query) {
    return 'https://www.base-search.net/Search/Results?type=all&ling=0&lookfor=' + query
  }
  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }
  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default BaseEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/BaseEngine.js